<script>
	let { columns = 3, rows = 1, subgrid = false, children } = $props();
</script>

<!-- eslint-disable better-tailwindcss/no-unknown-classes -->

<ul
	class="outer-grid"
	class:subgrid
	style="--column-count: {columns}; --row-count: {rows};"
>
	{@render children?.()}
</ul>

<style>
	.outer-grid {
		grid-auto-flow: row;
		display: grid;
		justify-content: space-between;
		grid-template-columns: 1fr;
		gap: 1rem;
		grid-column-gap: var(--column-gap, 1rem);
		grid-row-gap: var(--row-gap, 1rem);
		justify-items: center;
		width: 100%;
		padding: 0 var(--content-padding-x);
	}
	.outer-grid :global(li) {
		justify-items: center;
		gap: 1rem;
		display: grid;
	}

	.outer-grid :global(p),
	.outer-grid :global(h3) {
		padding: 0;
	}

	@media only screen and (min-width: 768px) {
		.outer-grid {
			grid-template-columns: repeat(var(--column-count, 1), 1fr);
			grid-template-rows: repeat(var(--row-count, 1), auto);
			grid-auto-flow: column;
			justify-items: var(--justify-items, center);
		}

		@supports (grid-template-rows: subgrid) {
			.subgrid :global(li) {
				display: grid;
				grid-template-rows: subgrid;
				grid-template-columns: subgrid;
				grid-row: 1 / var(--row-count, 1) span;
				justify-items: var(--justify-items, center);
			}
		}
		@supports not (grid-template-rows: subgrid) {
			.subgrid :global(li) {
				display: contents;
			}
		}
	}
</style>
